import { Action, ActionStatus } from './action';
import type { RootStore } from '~/stores/root.store';
import { IBaseFlowContext, TCommand } from '../../types/builder.types';
import { ActionType } from './server-requests-queue';

export class FlowAction<
    TContext extends IBaseFlowContext
> extends Action<TContext> {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        super();

        this.rootStore = rootStore;
    }

    applyCommands() {
        super.applyCommands();

        this.applyBulkActions(this.ctx.flow._id, this.ctx.commands);
    }

    revertCommands() {
        super.revertCommands();

        this.applyBulkActions(this.ctx.flow._id, this.ctx.revertCommands);
    }

    rollbackCommandsLocally() {
        super.rollbackCommandsLocally();

        const { fullstoryService, actionLoggerService } = this.rootStore;
        fullstoryService.info(
            'Rollbacking action only locally because action failed'
        );
        const actionLog = actionLoggerService.initActionLog();

        let actionType;
        if (this.status === ActionStatus.revertFailed) {
            this.applyCommands();

            if (this.applySideEffects) {
                this.applySideEffects();
            }

            actionType = ActionType.apply;
        } else if (
            this.status === ActionStatus.redoFailed ||
            this.status === ActionStatus.applyFailed
        ) {
            this.revertCommands();

            if (this.revertSideEffects) {
                this.revertSideEffects();
            }

            actionType = ActionType.undo;
        }

        actionLog?.addActionGeneralData(actionType, this);

        actionLoggerService.logActionLog();
    }

    protected applyBulkActions(flowId, commands: TCommand[]) {
        if (commands && commands.length) {
            this.rootStore.flowStore.applyBulkActions(flowId, commands);
        }
    }
}
